import React from "react";
import TestimonialSectionabout from "../pages/TestimonialSectionabout";
import VisionMission from "../pages/VisionMission";

const AboutSection = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">About Mumbai Airport Cab</h1>
          </div>
        </div>
      </div>

      {/* About Section */}
      <section className="py-3">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Images */}
            <div className="col-lg-6">
              <div className="image-box1">
                <img
                  className="img1"
                  src="/images/about.png"
                  alt="Mumbai Airport Cab Service"
                />

                {/* <img
                  className="img2"
                  src="/img/about/img-2-2.jpg"
                  alt="Airport Taxi Mumbai"
                /> */}

                {/* <div className="media-box1">
                  <span className="media-info">10+ Years</span>
                  <p className="media-text">Industry Experience</p>
                </div>

                <div className="media-box2">
                  <span className="media-info">50,000+</span>
                  <p className="media-text">Happy Travelers</p>
                </div> */}
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6">
              <div className="about-content">
                <div className="title-area">
                  <span className="sec-subtitle">
                    Your Trusted Airport Transfer Partner
                  </span>

                  <h2 className="sec-title h1">
                    Reliable Mumbai Airport Cab Services
                  </h2>

                  <p className="sec-text text-dark">
                    Mumbai Airport Cab is a trusted transportation provider
                    offering safe, comfortable, and affordable airport taxi
                    services across Mumbai and surrounding cities. We specialize
                    in airport pickups, drop-offs, local city travel,
                    outstation journeys, and corporate transportation with
                    professional chauffeurs and well-maintained vehicles.
                  </p>

                  <p className="sec-text text-dark">
                    Whether you're arriving at Chhatrapati Shivaji Maharaj
                    International Airport or heading to your destination, our
                    dedicated team ensures a hassle-free travel experience with
                    punctual service, transparent pricing, and 24/7 customer
                    support.
                  </p>
                </div>

                <h4 className="mb-3">Our Services</h4>

                <ul className="about-list1">
                  <li>24/7 Mumbai Airport Pickup & Drop Service</li>
                  <li>Domestic & International Airport Transfers</li>
                  <li>One-Way & Round-Trip Cab Booking</li>
                  <li>Local Mumbai Sightseeing & City Rides</li>
                  <li>Outstation Taxi Services Across Maharashtra</li>
                  <li>Corporate & Business Travel Solutions</li>
                  <li>Professional Drivers with Flight Tracking</li>
                  <li>Clean, Sanitized & GPS-Enabled Vehicles</li>
                </ul>

                {/* <p className="sec-text mt-4 text-dark">
                  Our fleet includes Hatchbacks, Sedans, SUVs, Innova Crysta,
                  Tempo Travellers, and Luxury Cars to suit every travel need.
                  From solo travelers to large groups, we provide customized
                  transportation solutions at competitive prices.
                </p> */}

               
              </div>
            </div>
          </div>

          {/* Additional Content */}
         
        </div>
      </section>

      <VisionMission />
      <TestimonialSectionabout />
    </>
  );
};

export default AboutSection;